/// <reference types="./cypress.d.mts" />
import * as $attribute from "../../lustre/lustre/attribute.mjs";

export function data(content) {
  return $attribute.attribute("data-cy", content);
}
